import Component from './CoreLayout';

// Libs
import { connect } from 'react-redux';

import { storeParams } from 'store/app';

const mapDispatchToProps = {
  storeParams,
};

const mapStateToProps = (state, ownProps) => {
  // This is needed even tho it's empty
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Component);
